import { Offcanvas, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import { UserInterface } from "./Customer";
import { useForm } from "react-hook-form";
import { Tab, Tabs } from "react-bootstrap";
import CompanyLogo from "../../assets/user.png"
import Transaction from "./Transaction";
// import TeamMember from "./TeamMember";
import Resources from "./Resources";
import Subscription from "./Subscription";
import HelperService from "../../utility/HelperService";

interface PropData {
    show: boolean
    handleClose: () => void
    data: UserInterface | null
}
const ViewOrganization = (props: PropData) => {
    const { register, handleSubmit, formState: { errors }, reset, setValue, watch, } = useForm<UserInterface>();
    const [isLoading, setLoading] = useState(false);
    const [bladeTitle, setBladeTitle] = useState("");
    const [selectedUser, setSelectedUser] = useState<UserInterface | null>(null);
    const [currentTab, setCurrentTab] = useState("InventoryIns");
    const [org, setOrg] = useState<any | null>(null);


    useEffect(() => {
        if (props.data) {
            setBladeTitle('User Details')
            reset(props.data)
            console.log(props.data.organization, "<<<")
            setSelectedUser(props.data)
            if (
                props.data.organization
            ) {
                console.log(props.data.organization, "<<<")
                // setUserType("ORGANIZATION");
                setOrg(props.data.organization);
            }
        } else {
            reset({})
            setBladeTitle('Add Customer')
        }
    }, [props.show])

    const getCurrentKey = (value: any) => {
        setCurrentTab(value);
    };
    const handleClose = props.handleClose;
    const show = props.show;
    const data = props.data;

    const onCloseModal = (e?: any) => {
        reset({})
        handleClose()
    }

    const getUserTypeLabel = (type?: string | null) => {
        if (!type) return "-";

        // 1️⃣ Organization nahi hai ya type ORGANIZATION nahi hai → kuch bhi mat dikhao
        if (!org || org.type !== "ORGANIZATION") {
            return "-";
        }
        if (type === "company manager" || type === "ORG-ADMIN") return "Company Manager";
        if (type !== "company manager" && type !== "ORG-ADMIN") return "Team Member";

        return type.replace(/_/g, " ");
    };

    return (
        <>
            <Offcanvas
                show={show}
                onHide={() => { reset(); onCloseModal(); }}
                placement="end"
                className="offcanvas-custom"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>{bladeTitle}</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="col-lg-12 bg-white rounded-2">
                        <div className="d-flex justify-content-end"></div>
                        <div className="custom-tabs">
                            <Tabs defaultActiveKey="serviceMaster" onSelect={getCurrentKey} className="mt-2">
                                <Tab eventKey="serviceMaster" title={<span>Information (Details)</span>}>
                                    <div className="p-2 h-100">
                                        <div className="card shadow-sm h-100">
                                            <div className="card-body">
                                                {/* Logo Image */}
                                                {/* <div className="mb-4 w-100 d-flex justify-content-center">
                                                    <img
                                                        src={data?.image ? data.image : CompanyLogo}
                                                        style={{ width: 100, height: 100, objectFit: "cover", borderRadius: "50%", border: "1px solid #ddd", background: "#f8f9fa" }}
                                                    />
                                                </div> */}
                                                {/* Details */}
                                                <div className="w-100">
                                                    <div className="row mb-3">
                                                        <div className="col-md-6 mb-2">
                                                            <strong className="text-muted me-2">Name:</strong>
                                                            <span className="text-dark">{data?.fullName || "-"}</span>
                                                        </div>
                                                        <div className="col-md-6 mb-2">
                                                            <strong className="text-muted me-2">Email:</strong>
                                                            <span className="text-dark">{data?.email || "-"}</span>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-6 mb-2">
                                                            <strong className="text-muted me-2">Phone:</strong>
                                                            <span className="text-dark">{data?.phone || "-"}</span>
                                                        </div>
                                                        <div className="col-md-6 mb-2">
                                                            <strong className="text-muted me-2">Username:</strong>
                                                            <span className="text-dark">{data?.username || "-"}</span>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-6 mb-2">
                                                            <strong className="text-muted me-2">Registration date:</strong>
                                                            <span className="text-dark">{HelperService.getFormatedDate(data?.createdAt)}</span>
                                                        </div>
                                                        <div className="col-md-6 mb-2">
                                                            <strong className="text-muted me-2">Last visited date:</strong>
                                                            <span className="text-dark">{HelperService.getFormatedDate(data?.lastVisitedAt)}</span>
                                                        </div>
                                                    </div>
                                                    {/* <div className="row mb-3">
                                                        <div className="col-md-6 mb-2">
                                                            <strong className="text-muted me-2">Address:</strong>
                                                            <span className="text-dark">{data?.address || "-"}</span>
                                                        </div>
                                                        <div className="col-md-6 mb-2">
                                                            <strong className="text-muted me-2">Country:</strong>
                                                            <span className="text-dark">
                                                                {[typeof data?.country === "object" && data?.country !== null ? (data.country as { name?: string }).name : data?.country,
                                                                typeof data?.state === "object" && data?.state !== null ? (data.state as { name?: string }).name : data?.state,
                                                                typeof data?.city === "object" && data?.city !== null ? (data.city as { name?: string }).name : data?.city
                                                                ].filter(Boolean).join(", ") || "-"}
                                                            </span>
                                                        </div>
                                                    </div> */}
                                                    <div className="row mb-3">
                                                        <div className="col-md-6 mb-2">
                                                            <strong className="text-muted me-2">Status:</strong>
                                                            <span
                                                                className={`badge ${data?.status === "ACTIVE" && data?.isVerified === "Y"
                                                                        ? "bg-success"
                                                                        : data?.status === "ACTIVE" && data?.isVerified === "N"
                                                                            ? "bg-warning text-dark"
                                                                            : "bg-secondary"
                                                                    }`}
                                                            >
                                                                {data?.status === "ACTIVE" && data?.isVerified === "N"
                                                                    ? "Not Verified"
                                                                    : data?.status === "ACTIVE" && data?.isVerified === "Y"
                                                                        ? "ACTIVE"
                                                                        : "Disabled"}
                                                            </span>
                                                        </div>
                                                        <div className="col-md-6 mb-2">
                                                            <strong className="text-muted me-2">User Group:</strong>
                                                            <span className="text-dark">{getUserTypeLabel(data?.type || "-")}</span>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-6 mb-2">
                                                            <strong className="text-muted me-2">Organization Name:</strong>
                                                            <span className="text-dark">{org?.type === "ORGANIZATION" ? org?.name : "-"}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* ================= ORGANIZATION DETAILS ================= */}
                                            {/*{org && org?.type === "ORGANIZATION" && (
                                                <div className="card-body">
                                                    <hr className="my-4" />

                                                    <h6 className="mb-3 text-primary">Organization Details</h6>


                                                    <div className="mb-4 w-100 d-flex justify-content-center">
                                                        <img
                                                            src={org?.logo || CompanyLogo}
                                                            alt="Organization Logo"
                                                            style={{
                                                                width: 100,
                                                                height: 100,
                                                                objectFit: "cover",
                                                                borderRadius: "50%",
                                                                border: "1px solid #ddd",
                                                                background: "#f8f9fa",
                                                            }}
                                                        />
                                                    </div>

                                                    <div className="row mb-3">
                                                        <div className="col-md-6 mb-2">
                                                            <strong className="text-muted me-2">Organization Name:</strong>
                                                            <span className="text-dark">{org?.name || "-"}</span>
                                                        </div>

                                                        <div className="col-md-6 mb-2">
                                                            <strong className="text-muted me-2">Email:</strong>
                                                            <span className="text-dark">{org?.email || "-"}</span>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3">
                                                        <div className="col-md-6 mb-2">
                                                            <strong className="text-muted me-2">Phone:</strong>
                                                            <span className="text-dark">{org?.phone || "-"}</span>
                                                        </div>

                                                        <div className="col-md-6 mb-2">
                                                            <strong className="text-muted me-2">Website:</strong>
                                                            <span className="text-dark">
                                                                {org?.website ? (
                                                                    <a
                                                                        href={org?.website}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        {org?.website}
                                                                    </a>
                                                                ) : (
                                                                    "-"
                                                                )}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3">
                                                        <div className="col-md-6 mb-2">
                                                            <strong className="text-muted me-2">GST Number:</strong>
                                                            <span className="text-dark">
                                                                {org?.gstNumber || "-"}
                                                            </span>
                                                        </div>

                                                        <div className="col-md-6 mb-2">
                                                            <strong className="text-muted me-2">Status:</strong>
                                                            <span
                                                                className={`badge ${org?.status === "ACTIVE"
                                                                    ? "bg-success"
                                                                    : "bg-secondary"
                                                                    }`}
                                                            >
                                                                {org?.status || "-"}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3">
                                                        <div className="col-md-12">
                                                            <strong className="text-muted me-2">Address:</strong>
                                                            <span className="text-dark">
                                                                {[
                                                                    org?.address,
                                                                    org?.city.city?.name,
                                                                    org?.state.state?.name,
                                                                    org?.country.country?.name,
                                                                    org?.pinCode,
                                                                ]
                                                                    .filter(Boolean)
                                                                    .join(", ") || "-"}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}*/}
                                        </div>
                                    </div>
                                </Tab>

                                {/* <Tab
                                    eventKey="subscription"
                                    title={<span>Subscription</span>}
                                >
                                    <div className="p-2 h-100">
                                        <Subscription data={selectedUser} />
                                    </div>
                                </Tab> */}

                                <Tab
                                    eventKey="transactions"
                                    title={<span>Transactions</span>}

                                >
                                    <div className="p-2 h-100">
                                        <Transaction data={selectedUser} />
                                    </div>

                                </Tab>

                                {/* <Tab
                                    eventKey="teamMembers"
                                    title={<span>Team Members</span>}
                                >
                                    <div className="p-2 h-100">
                                        <TeamMember data={selectedUser} />
                                    </div>
                                </Tab> */}

                                <Tab
                                    eventKey="resources"
                                    title={<span>Resources</span>}
                                >
                                    <div className="p-2 h-100">
                                        <Resources data={selectedUser} />
                                    </div>
                                </Tab>
                            </Tabs>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>

    );
};

export default ViewOrganization;
